import Formations from './Formations';

export const formationsRoutes = [{path: '/formations', name: 'Formations', Component: Formations}];
